"use client"

const TopMenuHeight = ({ hasBanner }) => {
  const menuHeight = `calc(var(--top-menu-height) + ${hasBanner ? 32 : 0}px)`

  return <div style={{ height: menuHeight }} />
}

export default TopMenuHeight
